import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/api.service';
import { PlanificadorService, Interfaceformdata } from '../components/models/control.service';
import { OptimalWallet } from 'src/app/interface/OptimalWallet';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { SseService } from './SseService';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModeloEjecucionService {

  // --- State Properties from ModelComponent ---
  Modelformdata: Interfaceformdata;
  optimalWallet: OptimalWallet;
  stopLoss: boolean = true;
  proFit: boolean = true;
  diasSalida: boolean = false;
  stopLossDinamico: boolean = true;
  bajista: boolean = false;
  periodico: boolean = false;
  salidaFinDia: boolean = false;
  repeticionEntradas: boolean = false;
  stopLossValue: number = 20;
  proFitValue: number = 20;
  diasSalidaValue: number = 0;
  selectedIdMercado: any;
  token: any;
  periodoModeloPeriodico: any;

  // --- Helper properties ---
  private totalactivosmodelo: number = 0;
  private modelotemporal: any;


  constructor(
    private apiService: ApiService,
    private apisseservice: SseService,
    private planificadorsv: PlanificadorService,
    private toastr: ToastrService,
    private cookieService: CookieService
  ) {
    this.token = this.cookieService.get('auth_token');
    // Initialize state from the PlanificadorService, similar to how ModelsComponent does
    this.planificadorsv.getFormdata().subscribe(datos => this.Modelformdata = datos);
    this.planificadorsv.valoptimaWallet$.subscribe(data => this.optimalWallet = data);
  }

  public ejecutarModeloPorId(idmodelo: number): Observable<any> {
    return new Observable(observer => {
      this.apisseservice.apiGetNew('parametrosmodelo?idmodelo=' + idmodelo).subscribe({
        next: (data: any) => {
          // 1. Set all the state properties from the response
          const condicionln = JSON.parse(data.condicionln);
          this.planificadorsv.condiciones = JSON.parse(data.lnList);
          this.Modelformdata.idMercado = condicionln.idmercado;
          this.Modelformdata.sectype = condicionln.sectype;
          this.Modelformdata.bajista = condicionln.bajista;
          this.Modelformdata.periodoModeloPeriodico = data.periodomodeloperiodico;
          this.Modelformdata.stoploss = condicionln.stopLoss;
          this.Modelformdata.profit = condicionln.profit;
          this.Modelformdata.stoplossCheck = condicionln.stopLossActivo;
          this.Modelformdata.profitCheck = condicionln.proFitActivo;
          this.Modelformdata.stoplossDinamicCheck = condicionln.stopLossDinamicActivo;
          this.Modelformdata.diasSalida = condicionln.diasSalida;
          this.Modelformdata.diasSalidaCheck = condicionln.diasSalidaActivo;
          this.stopLossValue = condicionln.stopLoss;
          this.proFitValue = condicionln.profit;
          this.stopLossDinamico = condicionln.stopLossDinamicActivo;
          this.proFit = condicionln.proFitActivo;
          this.stopLoss = condicionln.stopLossActivo;
          this.bajista = condicionln.bajista;
          this.diasSalida = condicionln.diasSalidaActivo;
          this.diasSalidaValue = condicionln.diasSalida;
          this.salidaFinDia = condicionln.salidaFinDiaActivo || false;
          this.Modelformdata.salidaFinDiaCheck = this.salidaFinDia;
          this.periodico = condicionln.periodoModeloPeriodico > 0;
          this.Modelformdata.periodoModeloPeriodico = condicionln.periodoModeloPeriodico;
          this.optimalWallet.prima = condicionln.periodoModeloPeriodico > 0;
          this.Modelformdata.fechaInicio = condicionln.start;
          this.selectedIdMercado = Number(condicionln.idmercado);
          this.planificadorsv.interpretacionDataListEntry = condicionln.list_conditions_entry;
          this.planificadorsv.interpretacionDataListExit = condicionln.list_conditions_exit;
          this.repeticionEntradas = condicionln.repeticionentradas;
          this.planificadorsv.noCondiciones = condicionln.nocondiciones;

          // 2. Call the model generation
          this.generateModel().subscribe({
            next: (event) => observer.next(event),
            error: (err) => observer.error(err),
            complete: () => observer.complete()
          });
        },
        error: (err: any) => {
          this.toastr.error('Error al obtener los parámetros del modelo');
          observer.error(err);
        }
      });
    });
  }

  private generateModel(): Observable<any> {
    return this.getMerca(this.Modelformdata);
  }

  private getMerca(data: any): Observable<any> {
    if (this.planificadorsv.interpretacionDataListEntry.length > 0 || this.planificadorsv.interpretacionDataListExit.length > 0 || this.planificadorsv.noCondiciones || this.periodico) {
      
      let primatemp = this.optimalWallet.prima;
      this.inicializarDataPlanificador();
      this.optimalWallet.prima = primatemp;
      this.planificadorsv.updateCarteraoptima();

      let jsonData = {
        list_conditions_entry: this.planificadorsv.interpretacionDataListEntry,
        list_conditions_exit: this.planificadorsv.interpretacionDataListExit,
        start: this.Modelformdata.fechaInicio,
        end: new Date().toISOString().split('T')[0],
        idnectums: [],
        stopLoss: this.Modelformdata.stoploss || this.stopLossValue,
        profit: this.Modelformdata.profit || this.proFitValue,
        bajista: this.Modelformdata.bajista,
        periodo: this.Modelformdata.period,
        idmercado: this.selectedIdMercado,
        sectype: this.Modelformdata.sectype,
        ln: this.planificadorsv.condiciones,
        periodoModeloPeriodico: this.Modelformdata.periodoModeloPeriodico,
        nocondiciones: this.planificadorsv.noCondiciones,
        repeticionentradas: this.repeticionEntradas,
        stopLossActivo: this.stopLoss,
        stopLossDinamicActivo: this.stopLossDinamico,
        proFitActivo: this.proFit,
        diasSalidaActivo: this.diasSalida,
        diasSalida: this.Modelformdata.diasSalida || this.diasSalidaValue,
        salidaFinDiaActivo: this.salidaFinDia,
        licencia: this.token
      };

      this.totalactivosmodelo = 0;
      this.modelotemporal = null;

      return this.apisseservice.apiGetSse('ia/crearmodelojava?data=', true, encodeURIComponent(JSON.stringify(jsonData)));
    }
    return new Observable(observer => observer.complete()); // Return empty observable if conditions not met
  }

  private inicializarDataPlanificador() {
    this.planificadorsv.updateOperation([]);
    this.planificadorsv.updateValoresLatente([]);
    this.planificadorsv.updateValoresLiquidativos([]);
    this.planificadorsv.updateopeVentas([]);
    this.planificadorsv.updateValRentabilidad([]);
    this.planificadorsv.updateValPos([]);
    this.planificadorsv.updateValRiesgo([]);
    this.planificadorsv.updateValRendAnual([]);
  }
}
